import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '@app/services/account.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.accountService.userValue;

        if (user) {
            var token = user.token;
            var payload: any = JSON.parse(atob(token.split('.')[1]));
            if(Date.now() / 1000 < payload.exp) {
                if(state.url === "/admin"){
                    let roles = payload['roles'];
                    if(roles.includes("cceClientAdmin")){
                        return true;
                    }
                }else{
                    return true;
                }
            }
        }

        this.router.navigate(['/account/login'], { queryParams: { returnURL: state.url } });
        return false;
    }
}